import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../../../constants/globalConstants'
import moment from 'moment'
import { getFacilityOpenDays } from '../../../utils/helper'

function RateDetailsModal(props) {
    const { rateDetailModal, setRateDetailModal, rateObj } = props
    const rateMap = rateObj.data?.length > 0 ? rateObj.data.map((res) => {
        let tme = res.exit_time_end.split(':')
        let entryTime = res.entry_time_end.split(':')
        let nxtDay = false
        if(Number(tme[0]) > 23) {
            tme[0] = Number(tme[0]) - 24
            nxtDay = true
        } else if (Number(entryTime[0]) > 23) {
            nxtDay = true
        }
        return {...res, exit_time_end: tme.join(':'), nextDay: nxtDay}
    }) : []
    const toggle = () => setRateDetailModal({...rateDetailModal, modal: !rateDetailModal.modal})
    return (
        <>
            <Modal isOpen={rateDetailModal.modal} scrollable={true} toggle={toggle}>
                <ModalHeader toggle={toggle}>Rate Details</ModalHeader>
                <ModalBody >
                    <table className='table table-sm '>
                        
                        {rateMap.length && rateMap.map((item, itemIndex) => <tr  key={'rate_detail_'+itemIndex}>
                            <td className='p-0 m-0 border-bottom pb-1'>
                                <div className='p-0 d-flex justify-content-between align-items-center'>
                                    <small className="p-0 fw-bold">{item?.rate_band_description}</small>
                                    <small className="p-0 fw-bold">${Number(item?.price).toFixed(2)}</small>                         
                                </div>
                            <div className='p-0 m-0 '>
                                {/* <small className='text-muted small p-0'>{Number(item?.min_stay).toFixed(2)} - {Number(item?.max_stay).toFixed(2)}</small> */}
                                <small className='text-muted small p-0 d-block'>{moment(item?.entry_time_begin, 'hh:mm:ss').format('hh:mm A')} - {moment(item?.exit_time_end, 'hh:mm:ss').format('hh:mm A')}{item?.nextDay ? ' (Next Day)':''}</small>
                                <small className='text-muted small p-0'>{getFacilityOpenDays(item)}</small>
                            </div>
                            </td>
                        </tr>)}
                    </table>
                </ModalBody>
            </Modal>
        </>
    )
}

RateDetailsModal.propTypes = {
    dispatch: PropTypes.func,
    rateDetailModal: PropTypes.object,
    rateObj: PropTypes.object,
    setRateDetailModal: PropTypes.func
}

RateDetailsModal.defaulProps = {
    dispatch: noop,
    rateDetailModal: EMPTY_OBJECT,
    rateObj: EMPTY_OBJECT,
    setRateDetailModal: noop
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(RateDetailsModal)